import React, { Component } from "react";
import "font-awesome/css/font-awesome.min.css";
import setIcon from "../images/settings.svg";
import orderprocessImg from "../images/order-process-icon.jpg";
import packagingImg from "../images/packaging-icon.jpg";
import customerImg from "../images/customer-return-icon.jpg";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./trainingCentre.css";

class TraningCentre extends Component {
  render() {
    return (
      <div className="main-container">
        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <div className="left-bar rounded h-100">
                <ul>
                  <li>
                    <Link to="/experiencezone/order-processing">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>Order Processing</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/experiencezone/packaging-information">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>Packaging Information</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/experiencezone/customer-returns">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>Customer Returns</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-9">
              <div className="inner-content">
                <h1>Traning Center</h1>
                <p>
                  Maximize your performance at the Seller Portal by learning all
                  these tutorials.
                </p>
              </div>
              <div className="inner-content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-4">
                      <Link to="/experiencezone/order-processing"
                        className="inner-link"
                      >
                        <h2 className="text-center">Order Processing</h2>
                      </Link>
                      <img
                        src={orderprocessImg}
                        alt=""
                        className="inner-icon"
                      />
                      <p className="text-center">
                        This course will provide the order processing procedure
                        for Ship from Store and CLiQ and Collect orders.
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <Link to="/experiencezone/packaging-information"
                        className="inner-link"
                      >
                        <h2 className="text-center">Packaging Information</h2>
                      </Link>
                      <img src={packagingImg} alt="" className="inner-icon" />
                      <p className="text-center">
                        This section provides you method of packing using
                        different packing materials such as boxes for
                        accessories, luxury etc.
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <Link to="/experiencezone/customer-returns"
                        className="inner-link"
                      >
                        <h2 className="text-center">Customer Returns</h2>
                      </Link>
                      <img src={customerImg} alt="" className="inner-icon" />
                      <p className="text-center">
                        This section provides steps for Customer initiated
                        return, Return to Origin and Return to store.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TraningCentre;
